import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageBackground from '../common/imageBackground';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';
import actionCategory from './images/categories/ActionThrillers_movies.png';
import classicsCategory from './images/categories/Classics_movies.png';
import comedyCategory from './images/categories/Comedy_movies.png';
import dramaCategory from './images/categories/Drama_movies.png';
import spanishCategory from './images/categories/EnEspanol_movies.png';
import kidsFamilyCategory from './images/categories/KidsFamily_movies.png';

class Category extends Component {
  /**************
   * Properties *
   **************/
  state = {
    elementsImage: require('./images/Movies_elements.png'),
    baseUrl: '/movies/categories',
    categories: {
      action: { page: 0, next: 'kids', previous: 'espanol', movie: 'action' },
      classics: { page: 1, next: 'comedy', previous: 'kids', movie: 'classics' },
      comedy: { page: 2, next: 'drama', previous: 'classics', movie: 'comedy' },
      drama: { page: 3, next: 'espanol', previous: 'comedy', movie: 'drama' },
      espanol: { page: 4, next: 'action', previous: 'drama', movie: 'espanol' },
      kids: { page: 5, next: 'classics', previous: 'action', movie: 'kids' }
    },
    pages: [actionCategory, classicsCategory, comedyCategory, dramaCategory, spanishCategory, kidsFamilyCategory],
    navigationBar: {
      back: true,
      backRoute: '/main_menu',
      mainMenu: true,
      navigate: true
    }
  };

  /*******************
   * Private methods *
   *******************/

  getCurrentCategoryName = () => this.props.match.params.categoryName;

  getCurrentCategory = () => this.state.categories[this.getCurrentCategoryName()];

  getCurrentCategoryImage = () => this.state.pages[this.getCurrentCategory().page];

  handlePageUp = () => this.props.history.push(`${this.state.baseUrl}/${this.getCurrentCategory().next}`);

  handlePageDown = () => this.props.history.push(`${this.state.baseUrl}/${this.getCurrentCategory().previous}`);

  handleSelect = () =>
    this.props.history.push(
      `${this.state.baseUrl}/${this.getCurrentCategoryName()}/${this.getCurrentCategory().movie}`
    );

  handleAlphaListing = () => this.props.history.push(`/movies/listing/${this.getCurrentCategoryName()}`);

  handleOnKeyUp = event => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case 'ArrowDown':
        this.handlePageUp();
        break;
      case 'ArrowUp':
        this.handlePageDown();
        break;
      case '1':
        this.handleAlphaListing();
        break;
      case 'Enter':
        this.handleSelect();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
        <ImageBackground id="background" />
        <ImageText id="text" src={this.state.elementsImage} />
        <img className="category-image" src={this.getCurrentCategoryImage()} alt="" />
        <NavigationBar {...this.state.navigationBar} />
        <button className="top-link" onMouseUp={this.handlePageDown} />
        <button className="bottom-link" onMouseUp={this.handlePageUp} />
        <button className="center-movie" onMouseUp={this.handleSelect} />
        <button className="alpha-link" onMouseUp={this.handleAlphaListing} />
      </div>
    );
  }
}

const ConnectedCategory = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(Category);

export default withRouter(ConnectedCategory);
